module.exports = __webpack_public_path__ + "static/media/marca.dc08c91a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallRecord/marca.svg
// module id = 1743
// module chunks = 0